import { Row, Col, Label, Form } from "reactstrap";
import DataProductTreeSelector from "./DataProductTreeSelector";
import RollCallStatusDomainsSelector from "./RollCallStatusDomainsSelector";
import FilterSubmit from "./FilterSubmit";

const RollCallFilterForm = () => (
  <Form>
    <Row className="bg-light-primary px-4 py-2">
      <Col>
        <Row className="align-items-end g-2">
          <Col xs="12" sm="auto" className="flex-grow-1">
            <Label className="mb-1 small">Data Products</Label>
            <DataProductTreeSelector />
          </Col>
          <Col xs="12" sm="auto" className="flex-grow-1">
            <Label className="mb-1 small">Roll-call Status</Label>
            <RollCallStatusDomainsSelector />
          </Col>
          <Col xs="12" sm="auto" className="d-flex align-items-end ms-sm-auto">
            <FilterSubmit color="primary" text="Filter" />
          </Col>
        </Row>
      </Col>
    </Row>
  </Form>
);

export default RollCallFilterForm;